import React, { useEffect, useState } from 'react'
import FailAlert from '../../../../../components/Alerts/FailAlert';
import { useMutation } from '@apollo/client';
import { ALL_FEATURES, CreateFeatures, UpdateFeatures, useAllFeatures } from '../../../../../graphql';
import useStore from '../../../../../store/useStore';
import LoadingWidget from '../../../../../components/LoadingWidget/LoadingWidget';
import { MdClose } from 'react-icons/md'
import { t } from 'i18next';
import i18n from 'i18next';

interface Props {
  setFeaturesPopup: React.Dispatch<React.SetStateAction<boolean>>,
  setSuccessMsg: React.Dispatch<React.SetStateAction<string>>,
  setSuccess: React.Dispatch<React.SetStateAction<boolean>>,
}

interface Feature {
  icon: string;
  title: string;
  description: string;
}

const AddFeatures = ({ setFeaturesPopup, setSuccess, setSuccessMsg }: Props) => {
  const [direction, setDirection] = useState(i18n.dir());

  useEffect(() => {
    const handleLanguageChange = () => {
      setDirection(i18n.dir());
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  const storeData = useStore((state: any) => state.userData.store);

  const [fail, setFail] = useState(false);
  const [failMsg, setFailMsg] = useState("");

  // i had to use a main state for control loading because of ui issues
  const [initialLoading, setInitialLoading] = useState(true);

  const [features, setFeatures] = useState<Feature[]>([
    { title: "", icon: "", description: "" },
    { title: "", icon: "", description: "" },
    { title: "", icon: "", description: "" },
  ]);

  const [allFeatures, { loading, data: dataAllFeatures }] = useAllFeatures();

  // Create
  const [createFeatures, { error, loading: CreateLoading }] = useMutation(CreateFeatures);
  const [updateFeatures, { error: updateError, loading: UpdateLoading }] = useMutation(UpdateFeatures);

  useEffect(() => {
    if (storeData) {
      (async () => {
        await allFeatures({
          variables: { idStore: storeData.id }
        })

        setInitialLoading(false)
      })()
    }

  }, [storeData]);

  useEffect(() => {
    if (initialLoading !== true) {
      if (dataAllFeatures?.allFeatures !== undefined && dataAllFeatures?.allFeatures.length !== 0) {

        const featuresArr: any[] = []

        dataAllFeatures?.allFeatures.map(feature => (
          featuresArr.push({
            idStore: storeData.id,
            title: feature.title,
            icon: feature.icon,
            description: feature.description,
          })
        ))

        setFeatures(featuresArr)

      }
    }
  }, [initialLoading, dataAllFeatures])


  const addFeatureForm = () => {
    setFeatures(prevFeatures => [
      ...prevFeatures,
      { name: "", icon: "", title: "", description: "" },
    ]);
  };

  const handleFeatureChange = (index: number, field: keyof Feature, value: string) => {
    setFeatures(prevFeatures => {
      const updatedFeatures = [...prevFeatures];
      updatedFeatures[index][field] = value;
      return updatedFeatures;
    });
  };

  const [iconDrop, setIconDrop] = useState(false);

  const [indexDrop, setIndexDrop] = useState<number>();

  const iconList = [
    "dice-6",
    "dice-5",
    "dice-4",
    "dice-3",
    "dice-2",
    "dice-1",
    "border-inner",
    "border-none",
    "glasses-alt",
    "glasses",
    "calendar-week",
    "scan",
    "bowling-ball",
    "book-reader",
    "arrow-to-bottom",
    "arrow-to-top",
    "arrow-to-left",
    "arrow-to-right",
    "arrow-from-right",
    "arrow-from-left",
    "arrow-from-bottom",
    "arrow-from-top",
    "current-location",
    "been-here",
    "webcam",
    "low-vision",
    "mask",
    "wifi-0",
    "wifi-1",
    "wifi-2",
    "traffic-cone",
    "spray-can",
    "recycle",
    "layer-minus",
    "layer-plus",
    "info-square",
    "home-heart",
    "heart-square",
    "heart-circle",
    "microchip",
    "pointer",
    "coffee-togo",
    "calendar-edit",
    "cabinet",
    "bus-school",
    "bomb",
    "bible",
    "beer",
    "baseball",
    "atom",
    "arch",
    "location-plus",
    "align-left",
    "align-middle",
    "align-right",
    "arrow-back",
    "bell-minus",
    "bell-off",
    "bell-plus",
    "bell",
    "bookmark",
    "bookmarks",
    "bullseye",
    "camera-off",
    "camera",
    "captions",
    "checkbox-checked",
    "checkbox",
    "checkbox-square",
    "chevron-down",
    "chevron-up",
    "chevron-left",
    "chevron-right",
    "chevrons-down",
    "chevrons-up",
    "chevrons-right",
    "chevrons-left",
    "clipboard",
    "code-curly",
    "code",
    "coffee",
    "copy",
    "copyright",
    "down-arrow-circle",
    "error-circle",
    "error",
    "exit-fullscreen",
    "fast-forward-circle",
    "fast-forward",
    "first-page",
    "folder-minus",
    "folder-plus",
    "folder",
    "fullscreen",
    "hide",
    "image",
    "info-circle",
    "align-justify",
    "key",
    "last-page",
    "left-arrow-circle",
    "left-down-arrow-circle",
    "left-indent",
    "left-top-arrow-circle",
    "menu",
    "microphone",
    "minus-circle",
    "moon",
    "pause-circle",
    "pause",
    "play-circle",
    "play",
    "plus-circle",
    "question-mark",
    "radio-circle-marked",
    "radio-circle",
    "rectangle",
    "rewind",
    "reset",
    "right-arrow-circle",
    "right-down-arrow-circle",
    "right-indent",
    "right-top-arrow-circle",
    "rss",
    "search",
    "show",
    "skip-next",
    "skip-previous",
    "stop-circle",
    "stop",
    "stopwatch",
    "sync",
    "time",
    "toggle-left",
    "toggle-right",
    "trending-down",
    "trending-up",
    "up-arrow-circle",
    "vertical-center",
    "video",
    "volume-full",
    "volume-low",
    "volume-mute",
    "volume",
    "x-circle",
    "zoom-in",
    "zoom-out",
    "archive",
    "at",
    "bar-chart-alt",
    "bar-chart-square",
    "bar-chart",
    "basketball",
    "block",
    "book-bookmark",
    "book",
    "bookmark-minus",
    "bookmark-plus",
    "briefcase",
    "broadcast",
    "building",
    "bug",
    "bluetooth",
    "bulb",
    "buoy",
    "calendar-plus",
    "calendar-check",
    "calendar-minus",
    "calendar-x",
    "calendar",
    "chart",
    "cloud-download",
    "cloud-upload",
    "cloud",
    "terminal",
    "crosshair",
    "compass",
    "data",
    "desktop",
    "directions",
    "dollar",
    "dots-horizontal-rounded",
    "dots-horizontal",
    "dots-vertical-rounded",
    "dots-vertical",
    "download",
    "envelope",
    "gift",
    "globe",
    "devices",
    "headphone",
    "heart",
    "home",
    "laptop",
    "layer",
    "link-alt",
    "link",
    "list-plus",
    "list-ul",
    "list-minus",
    "lock-open",
    "lock",
    "map-alt",
    "map",
    "message-rounded",
    "message",
    "mobile-alt",
    "mobile",
    "navigation",
    "phone",
    "pie-chart",
    "send",
    "sidebar",
    "sitemap",
    "spreadsheet",
    "tab",
    "tag",
    "target-lock",
    "tennis-ball",
    "alarm",
    "upload",
    "usb",
    "video-off",
    "voicemail",
    "wifi",
    "window-open",
    "window",
    "windows",
    "duplicate",
    "table",
    "x",
    "adjust",
    "album",
    "anchor",
    "award",
    "bold",
    "calculator",
    "cart",
    "check",
    "cloud-drizzle",
    "cloud-light-rain",
    "cloud-lightning",
    "cloud-rain",
    "cloud-snow",
    "cog",
    "columns",
    "credit-card",
    "crop",
    "cube",
    "cut",
    "detail",
    "diamond",
    "edit",
    "file",
    "filter",
    "font",
    "git-branch",
    "git-commit",
    "git-compare",
    "git-merge",
    "git-pull-request",
    "git-repo-forked",
    "group",
    "hash",
    "heading",
    "home-alt",
    "italic",
    "joystick",
    "link-external",
    "log-in",
    "log-out",
    "microphone-off",
    "minus",
    "mouse",
    "move",
    "music",
    "notification",
    "package",
    "paragraph",
    "paste",
    "pencil",
    "pin",
    "plus",
    "power-off",
    "pulse",
    "save",
    "screenshot",
    "select-multiple",
    "share-alt",
    "share",
    "shield-alt",
    "shield",
    "shopping-bag",
    "shuffle",
    "sort",
    "star",
    "sun",
    "text",
    "trash",
    "trophy",
    "underline",
    "user-check",
    "user-circle",
    "user-minus",
    "user-plus",
    "user-x",
    "user",
    "barcode",
    "crown",
    "dislike",
    "down-arrow",
    "export",
    "first-aid",
    "flag",
    "history",
    "joystick-alt",
    "left-arrow",
    "like",
    "list-check",
    "poll",
    "radar",
    "redo",
    "reply-all",
    "reply",
    "repost",
    "revision",
    "right-arrow",
    "subdirectory-left",
    "subdirectory-right",
    "support",
    "timer",
    "undo",
    "up-arrow",
    "phone-call",
    "aperture",
    "film",
    "folder-open",
    "task",
    "server",
    "battery",
    "calendar-alt",
    "import",
    "ruler",
    "horizontal-center",
    "rotate-right",
    "rename",
    "collapse",
    "phone-incoming",
    "phone-outgoing",
    "body",
    "cast",
    "chip",
    "skip-next-circle",
    "skip-previous-circle",
    "hdd",
    "store",
    "globe-alt",
    "upvote",
    "downvote",
    "news",
    "pie-chart-alt",
    "images",
    "purchase-tag",
    "pen",
    "expand",
    "paperclip",
    "closet",
    "tv",
    "collection",
    "station",
    "wallet",
    "briefcase-alt",
    "hourglass",
    "carousel",
    "infinite",
    "plug",
    "notification-off",
    "window-close",
    "command",
    "grid-alt",
    "trash-alt",
    "chalkboard",
    "loader",
    "slider",
    "paper-plane",
    "selection",
    "world",
    "dock-bottom",
    "dock-right",
    "dock-top",
    "dock-left",
    "layout",
    "alarm-off",
    "wrench",
    "loader-circle",
    "loader-alt",
    "car",
    "cart-alt",
    "happy",
    "meh",
    "sad",
    "slider-alt",
    "certification",
    "rocket",
    "check-circle",
    "bus",
    "check-double",
    "dumbbell",
    "bot",
    "area",
    "bed",
    "bath",
    "train",
    "taxi",
    "movie",
    "hotel",
    "planet",
    "list-ol",
    "video-plus",
    "menu-alt-left",
    "menu-alt-right",
    "box",
    "restaurant",
    "swim",
    "water",
    "wind",
    "dialpad",
    "handicap",
    "font-size",
    "code-block",
    "photo-album",
    "strikethrough",
    "file-blank",
    "highlight",
    "font-color",
    "fingerprint",
    "transfer",
    "circle",
    "ball",
    "football",
    "dollar-circle",
    "search-alt",
    "analyse",
    "disc",
    "equalizer",
    "stats",
    "move-horizontal",
    "move-vertical",
    "grid-horizontal",
    "grid-vertical",
    "grid-small",
    "badge",
    "id-card",
    "sort-up",
    "sort-down",
    "note",
    "test-tube",
    "help-circle",
    "card",
    "rewind-circle",
    "magnet",
    "calendar-event",
    "caret-left",
    "caret-up",
    "caret-right",
    "caret-down",
    "show-alt",
    "badge-check",
    "rotate-left",
    "brush",
    "unlink",
    "paint",
    "joystick-button",
    "font-family",
    "repeat",
    "walk",
    "money",
    "home-circle",
    "buildings",
    "store-alt",
    "bar-chart-alt-2",
    "message-dots",
    "message-rounded-dots",
    "memory-card",
    "wallet-alt",
    "slideshow",
    "message-square",
    "message-square-dots",
    "book-content",
    "chat",
    "edit-alt",
    "mouse-alt",
    "bug-alt",
    "notepad",
    "video-recording",
    "shape-square",
    "shape-triangle",
    "ghost",
    "mail-send",
    "code-alt",
    "grid",
    "user-pin",
    "run",
    "copy-alt",
    "transfer-alt",
    "book-open",
    "landscape",
    "comment",
    "comment-dots",
    "pyramid",
    "cylinder",
    "lock-alt",
    "lock-open-alt",
    "left-arrow-alt",
    "right-arrow-alt",
    "up-arrow-alt",
    "down-arrow-alt",
    "shape-circle",
    "cycling",
    "dna",
    "search-alt-2",
    "plus-medical",
    "street-view",
    "droplet",
    "paint-roll",
    "shield-alt-2",
    "error-alt",
    "square",
    "square-rounded",
    "polygon",
    "cube-alt",
    "cuboid",
    "user-voice",
    "accessibility",
    "building-house",
    "doughnut-chart",
    "log-in-circle",
    "log-out-circle",
    "check-square",
    "message-alt",
    "message-alt-dots",
    "no-entry",
    "palette",
    "basket",
    "purchase-tag-alt",
    "receipt",
    "line-chart",
    "map-pin",
    "hive",
    "band-aid",
    "credit-card-alt",
    "wifi-off",
    "brightness-half",
    "brightness",
    "filter-alt",
    "dialpad-alt",
    "border-right",
    "border-left",
    "border-top",
    "border-bottom",
    "border-all",
    "mobile-landscape",
    "mobile-vibration",
    "gas-pump",
    "pie-chart-alt-2",
    "time-five",
    "briefcase-alt-2",
    "brush-alt",
    "customize",
    "radio",
    "printer",
    "sort-a-z",
    "sort-z-a",
    "conversation",
    "exit",
    "extension",
    "face",
    "file-find",
    "label",
    "check-shield",
    "border-radius",
    "add-to-queue",
    "archive-in",
    "archive-out",
    "alarm-add",
    "space-bar",
    "image-alt",
    "image-add",
    "fridge",
    "dish",
    "spa",
    "cake",
    "bolt-circle",
    "tone",
    "bitcoin",
    "lira",
    "ruble",
    "rupee",
    "euro",
    "pound",
    "won",
    "yen",
    "shekel",
    "health",
    "clinic",
    "male",
    "female",
    "male-sign",
    "female-sign",
    "food-tag",
    "food-menu",
    "meh-alt",
    "wink-tongue",
    "happy-alt",
    "cool",
    "tired",
    "smile",
    "angry",
    "happy-heart-eyes",
    "dizzy",
    "wink-smile",
    "confused",
    "sleepy",
    "shocked",
    "happy-beaming",
    "meh-blank",
    "laugh",
    "upside-down",
    "shield-quarter",
    "sticker"
  ];

  const submit = async (e: any) => {

    e.preventDefault();

    for (var i = 0; i < features.length; i++) {
      if (features[i].title === "" || features[i].icon === "" || features[i].description === "") {
        setFailMsg(t('formNonComplete'));
        setFail(true);
        return
      }
    }

    const featuresArr: any[] = []

    features.map(feature => (
      featuresArr.push({
        idStore: storeData.id,
        title: feature.title,
        icon: feature.icon,
        description: feature.description,
        rank: 2
      })
    ))

    if (dataAllFeatures?.allFeatures !== undefined && dataAllFeatures?.allFeatures.length !== 0) {
      // Only update if there is Features before
      await updateFeatures({
        variables: {
          idStore: storeData.id,
          content: featuresArr
        },
        refetchQueries: [{ query: ALL_FEATURES, variables: { idStore: storeData.id } }]
      })

      if (!updateError) {
        setSuccessMsg(t('featuresUpdatedSuccess'));
        setSuccess(true);
        setFeaturesPopup(false)
      }
    } else {
      // Create Features if there is no features before
      await createFeatures({
        variables: {
          content: featuresArr
        },
        refetchQueries: [{ query: ALL_FEATURES, variables: { idStore: storeData.id } }]
      })

      if (!error) {
        setSuccessMsg(t('featuresAddedSuccess'));
        setSuccess(true);
        setFeaturesPopup(false)
      }
    }
  }

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center w-full min-h-screen py-6 bg-gray-900/10 backdrop-blur-md'>

      {fail && <FailAlert fail={fail} setFail={setFail} failMsg={failMsg} />}

      <div className='relative w-full p-2 overflow-y-auto bg-white border md:w-5/6 h-[90%]'>
        {initialLoading ?
          <LoadingWidget />
          :
          loading ?
            <LoadingWidget />
            :
            <div>
              {CreateLoading &&
                <div className='fixed top-0 left-0 z-30 flex items-center justify-center w-full h-full py-10 bg-white/70'>
                  <svg aria-hidden="true" className="w-8 h-8 mr-2 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                  </svg>
                </div>
              }

              {UpdateLoading &&
                <div className='fixed top-0 left-0 z-30 flex items-center justify-center w-full h-full py-10 bg-white/70'>
                  <svg aria-hidden="true" className="w-8 h-8 mr-2 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                  </svg>
                </div>
              }

              <div className='flex justify-end py-2 text-gray-600'>
                <div onClick={() => setFeaturesPopup(false)} className='cursor-pointer'>
                  <MdClose size={20} />
                </div>
              </div>

              {features.map((feature, index) => (
                <div key={index} className='mb-6'>
                  <div className="relative mb-2">
                    <button onClick={(e) => { e.preventDefault(); setIndexDrop(index); setIconDrop(!iconDrop) }} className="z-10 flex items-center justify-between p-2 text-left text-gray-700 border border-gray-300 rounded-md bg-gray-50 focus:border-primary focus:outline-none">
                      <span className='mr-3'>
                        {feature.icon !== "" ?
                          <div className='flex items-center justify-center'>
                            <box-icon name={feature.icon}></box-icon>
                          </div>
                          :
                          t("select")
                        }
                      </span>

                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M16.939 10.939 12 15.879l-4.939-4.94-2.122 2.122L12 20.121l7.061-7.06z"></path>
                        <path d="M16.939 3.939 12 8.879l-4.939-4.94-2.122 2.122L12 13.121l7.061-7.06z"></path>
                      </svg>
                    </button>

                    {iconDrop &&
                      indexDrop === index &&
                      <div className={`absolute ${direction === 'ltr' ? 'left-0' : "right-0"} z-20 w-2/4 py-2 mt-2 origin-top-right bg-white border border-gray-300 rounded-md shadow-xl`}>
                        <div className='flex flex-wrap items-center gap-2 overflow-y-auto h-72'>
                          {iconList.map((icon) => (
                            <div key={icon} onClick={(e) => { setIconDrop(false); handleFeatureChange(index, 'icon', icon) }}>
                              <div className="flex items-center justify-center p-2 text-sm text-gray-600 capitalize transition-colors duration-300 transform cursor-pointer hover:bg-gray-100">
                                <box-icon name={icon}></box-icon>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    }
                  </div>

                  <div className="my-2">
                    <input type="text" value={feature.title} onChange={(e) => handleFeatureChange(index, 'title', e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary outline-none block w-full p-2.5" placeholder={t('title')} required />
                  </div>
                  <div className="my-2">
                    <input type="text" value={feature.description} onChange={(e) => handleFeatureChange(index, 'description', e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary outline-none block w-full p-2.5" placeholder={t('description')} required />
                  </div>
                </div>
              ))}

              <div className='my-2 '>
                <button onClick={addFeatureForm} className='inline-flex items-center justify-center px-4 py-2 my-2 overflow-hidden text-sm text-white transition-colors duration-300 rounded-lg shadow bg-primary sm:w-auto md:my-0 hover:bg-primaryHover'>
                  <span className="mx-2">
                    {t('addFeature')}
                  </span>
                </button>
              </div>

              <div className='flex justify-end my-2'>
                <div>
                  <button onClick={(e) => submit(e)} className='inline-flex items-center justify-center px-4 py-2 my-2 overflow-hidden text-sm text-white transition-colors duration-300 rounded-lg shadow bg-primary sm:w-auto md:my-0 hover:bg-primaryHover'>
                    <span className="mx-2">
                      {t('save')}
                    </span>
                  </button>
                </div>
              </div>
            </div>
        }
      </div>
    </div >
  )
}

export default AddFeatures